var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 mt-10" },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { align: "left" },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                [
                  _vm.anonymousDisplayEnable
                    ? [_vm._v(" " + _vm._s("来客人数/") + " ")]
                    : _vm._e(),
                  _vm._v(" " + _vm._s("顔認識データ取得数") + " "),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0 mr-1",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { justify: "end" },
            },
            [
              _vm.anonymousDisplayEnable
                ? [
                    _c("v-img", {
                      staticClass: "ma-0 pa-0 mr-2",
                      attrs: {
                        "max-height": "1.2rem",
                        "max-width": "1.2rem",
                        src: require("@/assets/images/light_grey_box.png"),
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.ta("unacquiredNumber")) + " "),
                  ]
                : _vm._e(),
              _c("v-img", {
                staticClass: "ma-0 pa-0 ml-5 mr-2",
                attrs: {
                  "max-height": "1.2rem",
                  "max-width": "1.2rem",
                  src: require("@/assets/images/yellow_box.png"),
                },
              }),
              _vm._v(" " + _vm._s(_vm.ta("numberOfAcquisitions")) + " "),
            ],
            2
          ),
        ],
        1
      ),
      _c("AnalyticsChart", {
        attrs: {
          mode: _vm.mode,
          fetchLoading: _vm.fetchLoading,
          monthNoData: _vm.monthNoData,
          chartData: _vm.visitorDataset,
          chartOptions: _vm.visitorChartOption,
          visitorData: _vm.visitorData,
        },
      }),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 mt-5" },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { align: "left" },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                    [_vm._v(" " + _vm._s(_vm.ta("manAndWoman")) + " ")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0 pl-3", attrs: { cols: "3" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showAgeManAndWoman,
                                expression: "showAgeManAndWoman",
                              },
                            ],
                            attrs: { id: "check_box", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.showAgeManAndWoman)
                                ? _vm._i(_vm.showAgeManAndWoman, null) > -1
                                : _vm.showAgeManAndWoman,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showAgeManAndWoman,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showAgeManAndWoman = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showAgeManAndWoman = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showAgeManAndWoman = $$c
                                }
                              },
                            },
                          }),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 ml-3",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s("年代別を表示"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0 mr-1",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { justify: "end" },
            },
            [
              _c("v-img", {
                staticClass: "ma-0 pa-0 mr-2",
                attrs: {
                  "max-height": "1.2rem",
                  "max-width": "1.2rem",
                  src: require("@/assets/images/blue_box.png"),
                },
              }),
              _vm._v(" " + _vm._s(_vm.ta("man")) + " "),
              _c("v-img", {
                staticClass: "ma-0 pa-0 ml-5 mr-2",
                attrs: {
                  "max-height": "1.2rem",
                  "max-width": "1.2rem",
                  src: require("@/assets/images/pink_box.png"),
                },
              }),
              _vm._v(" " + _vm._s(_vm.ta("woman")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c("AnalyticsChart", {
        attrs: {
          mode: _vm.mode,
          fetchLoading: _vm.fetchLoading,
          monthNoData: _vm.monthNoData,
          chartData: _vm.genderDataset,
          chartOptions: _vm.genderChartOption,
          visitorData: _vm.visitorData,
          showAge: true,
          showAgeValue: _vm.showAgeManAndWoman,
          manOrWoman: true,
        },
      }),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 mt-5" },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { align: "left" },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                    [_vm._v(" " + _vm._s(_vm.ta("newOrRepeatCustomers")) + " ")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0 pl-3", attrs: { cols: "3" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showAgeNewOrRepeatCustomers,
                                expression: "showAgeNewOrRepeatCustomers",
                              },
                            ],
                            attrs: { id: "check_box", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.showAgeNewOrRepeatCustomers
                              )
                                ? _vm._i(
                                    _vm.showAgeNewOrRepeatCustomers,
                                    null
                                  ) > -1
                                : _vm.showAgeNewOrRepeatCustomers,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showAgeNewOrRepeatCustomers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showAgeNewOrRepeatCustomers =
                                        $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showAgeNewOrRepeatCustomers = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showAgeNewOrRepeatCustomers = $$c
                                }
                              },
                            },
                          }),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 ml-3",
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s("年代別を表示"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0 mr-1",
              staticStyle: { "font-size": "0.8rem" },
              attrs: { justify: "end" },
            },
            [
              _c("v-img", {
                staticClass: "ma-0 pa-0 mr-2",
                attrs: {
                  "max-height": "1.2rem",
                  "max-width": "1.2rem",
                  src: require("@/assets/images/green_box.png"),
                },
              }),
              _vm._v(" " + _vm._s(_vm.ta("repeatCustomer")) + " "),
              _c("v-img", {
                staticClass: "ma-0 pa-0 ml-5 mr-2",
                attrs: {
                  "max-height": "1.2rem",
                  "max-width": "1.2rem",
                  src: require("@/assets/images/purple_box.png"),
                },
              }),
              _vm._v(" " + _vm._s(_vm.ta("new")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c("AnalyticsChart", {
        attrs: {
          mode: _vm.mode,
          fetchLoading: _vm.fetchLoading,
          monthNoData: _vm.monthNoData,
          chartData: _vm.repeaterDataset,
          chartOptions: _vm.repeaterChartOption,
          visitorData: _vm.visitorData,
          showAge: true,
          showAgeValue: _vm.showAgeNewOrRepeatCustomers,
          manOrWoman: false,
        },
      }),
      _c("AnalyticsDownload", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.period == "30day" || _vm.period == "fromto"
                ? _vm.totalVisitData
                : _vm.visitorData.length != 0 || !_vm.monthNoData,
            expression:
              "(period == '30day' || period == 'fromto') ? totalVisitData : (visitorData.length != 0 || !monthNoData)",
          },
        ],
        attrs: {
          modeData: _vm.downloadMode,
          periodData: _vm.downloadPeriod,
          startDate: _vm.startDate,
          endDate: _vm.endDate,
          pageName: _vm.pageName,
          leftSide: _vm.leftSide,
        },
        on: { totalVisitorData: _vm.totalVisitorDataFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }